import React from 'react';
import {connect} from 'react-redux';
import strings from 'utils/strings';

import {updateObject} from 'utils/reducerUtils';
import AudioPlayer from 'components/AudioPlayer';
import * as noTutorialLower from './languages/no-tutorial.js';
import * as nnTutorialLower from './languages/nn-tutorial.js';
const tutorialObjLowerGrade = {
	no: noTutorialLower,
	nn: nnTutorialLower,
};

let count = 1;
let answerArray = [];

class Tutorial extends React.Component {
	constructor(props) {
		super(props);

		this.tutorial = tutorialObjLowerGrade[strings.getLanguage()];
		this.tutorialAssignment = this.tutorial.tutorialAssignment;
		this.assignments = this.tutorial.assignments;
		this.exampleSound = this.tutorial.exampleSound;
		this.dinTurSound = this.tutorial.dinTurSound;
		this.starterTestenSound = this.tutorial.starterTestenSound;

		const results = {};

		for (const assignment of this.assignments) {
			results[assignment.id] = '';
		}
		this.state = {
			hasPlayedFirstAudio: false,
			results,
			counter: 1,
			selectedItems: [],
			choiceId: null,
			choiceValue: null,
			limit: 6,
			/* hideComment: false, */
			showTestPanel: true,
			nextTutorial: false,
			imageClass: 'imgItem',
			wrongAnswerDetected: false,
			correctAnswerDetected: false,
			halfAnswerDetected: false,
			selectedGroupId: null,
			hoverDisabled: false,
			showOptions: false,
			singleAssignment: {
				1: this.tutorial.assignment1,
				2: this.tutorial.assignment2,
				3: this.tutorial.assignment3,
				4: this.tutorial.assignment4,
				5: this.tutorial.assignment5,
			},
			defaultAssignments: {
				1: this.tutorial.assignment1,
				2: this.tutorial.assignment2,
				3: this.tutorial.assignment3,
				4: this.tutorial.assignment4,
				5: this.tutorial.assignment5,
			},
		};

		this.audioRefs = {};
	}

	handleImageClick(item, assignmentId) {
		const {answerArray = []} = this.state;

		if (answerArray.includes(item.word)) {
			return;
		}

		const updatedAnswerArray = [...answerArray, item.word];
		item.currentClass = 'imgItem__clicked';
		this.setResults(assignmentId, {
			isCorrect: true,
			isAnswered: true,
			answerArray: updatedAnswerArray,
		});

		this.setState({
			answerArray: updatedAnswerArray,
		});
	}

	recordAnswerSetSyle(assignment, groupId, range) {
		const {singleAssignment, counter} = this.state;
		const [currentAssignment] = assignment;
		const {choices, order, id} = currentAssignment;

		const updateChoiceClass = (groupId, newClass) => {
			for (const choice of choices) {
				for (const group of choice.choiceGroup) {
					if (group.groupId === groupId) {
						group.currentClass = newClass;
						return;
					}
				}
			}
		};

		if (order.length >= answerArray.length) {
			for (const choice of choices) {
				for (const group of choice.choiceGroup) {
					if (
						group.groupId === groupId &&
						!answerArray.includes(group.word)
					) {
						answerArray.push(group.word);
						group.currentClass = 'imgItem__selected';
						break;
					}
				}
			}

			if (range < 3) {
				const lastAnswerIndex = answerArray.length - 1;
				const isCorrect =
					order[lastAnswerIndex] === answerArray[lastAnswerIndex];

				if (!isCorrect) {
					answerArray.pop();
					updateChoiceClass(groupId, 'imgItem__wrong');
					this.setState({
						wrongAnswerDetected: true,
						selectedGroupId: groupId,
						hoverDisabled: true,
					});
				} else {
					updateChoiceClass(groupId, 'imgItem__clicked');
					this.setState({
						correctAnswerDetected: true,
						hoverDisabled: true,
					});
				}
				singleAssignment[counter] = assignment;
				this.setState({...singleAssignment});
				this.setResults(id, {answerArray});
			} else if (order.length === answerArray.length) {
				const {correct, present} = this.compareAnswers(
					order,
					answerArray
				);

				if (correct === order.length) {
					choices.forEach((choice) => {
						choice.choiceGroup.forEach((group) => {
							if (answerArray.includes(group.word)) {
								group.currentClass = 'imgItem__clicked';
							}
						});
					});
					this.setState({
						correctAnswerDetected: true,
						hoverDisabled: true,
						singleAssignment,
					});
				} else if (correct + present === order.length) {
					this.setState({
						halfAnswerDetected: true,
						hoverDisabled: true,
					});
				} else {
					choices.forEach((choice) => {
						choice.choiceGroup.forEach((group) => {
							if (answerArray.includes(group.word)) {
								group.currentClass = 'imgItem__wrong';
							}
						});
					});
					this.setState({
						wrongAnswerDetected: true,
						hoverDisabled: true,
					});
				}

				singleAssignment[counter] = assignment;
				this.setState({...singleAssignment});
			}
			singleAssignment[counter] = assignment;
			this.setState({...singleAssignment});
			this.setResults(id, {answerArray});
		}
	}

	compareAnswers(correctAnswer = [], userAnswer = []) {
		return userAnswer.reduce(
			(result, userItem, index) => {
				const correctItem = correctAnswer[index];

				if (userItem === correctItem) {
					result.correct++;
				} else if (correctAnswer.includes(userItem)) {
					result.present++;
				} else {
					result.incorrect++;
				}

				return result;
			},
			{correct: 0, present: 0, incorrect: 0}
		);
	}
	preloadImages = (urls = []) => {
		const tasks = urls.map((src) => {
			const img = new Image();
			img.src = src;
			return img.decode?.().catch(() => {}); // ignore decode errors
		});
		return Promise.all(tasks);
	};

	componentDidMount() {
		this.preloadCurrent();
	}

	componentDidUpdate(prevProps, prevState) {
		if (prevState.counter !== this.state.counter) this.preloadCurrent();
	}

	preloadCurrent() {
		if (this.state.counter < 3) {
			const [assignment] =
				this.state.singleAssignment[this.state.counter];
			const urls = assignment.choices.flatMap((c) =>
				c.choiceGroup.map((g) => g.img)
			);
			this.preloadImages(urls);
		}
	}

	setResults(id, value) {
		const {results} = this.state;
		this.setState({
			results: updateObject(results, {
				[id]: value,
			}),
			choiceId: id,
			choiceValue: value,
		});
	}
	updateCount() {
		const {results} = this.state;
		this.setState(
			{
				results: updateObject(results, {
					[this.state.choiceId]: this.state.choiceValue,
				}),
			},
			() => {
				this.setState({
					counter: count,
					/* hideComment: true, */
					showTestPanel: false,
					nextTutorial: true,
					showOptions: false,
				});
				this.props.onShowAvatar(true);
			}
		);
	}
	scrollToTop = () => {
		window.scrollTo({
			top: 169,
			behavior: 'smooth',
		});
	};

	render() {
		const {onNextStep} = this.props;

		const {hasPlayedFirstAudio, results, singleAssignment} = this.state;

		const allResultsHasValues = Object.keys(results).every(
			(key) => results[key]
		);

		const isNextButtonVisible = count === 3;

		return (
			<div className="lit-test" style={{marginTop: '-20px'}}>
				<div className="lit-sprakforstaelse lit-sprakforstaelse__tutorial">
					{count < 3 &&
						singleAssignment[this.state.counter].map(
							(assignment) => {
								const {id, choices, order} = assignment;
								let partialAnswerFeedback;
								if (order.length > 1) {
									partialAnswerFeedback = (
										<>
											<br />
											<p className="feedback">
												<AudioPlayer
													strokeColor="#f4e807ff"
													outlineColor="#4f5151ff"
													autoplay
													inline
													onErrorPlay={() => {
														console.log(
															'Something went wrong'
														);
													}}
													onComplete={() => {
														choices.forEach(
															(choice) => {
																choice.choiceGroup.forEach(
																	(group) => {
																		group.currentClass =
																			'imgItem';
																	}
																);
															}
														);
														answerArray = [];
														singleAssignment[
															this.state.counter
														] = [assignment];

														this.setState({
															singleAssignment,
															correctAnswerDetected: false,
															halfAnswerDetected: false,
															hoverDisabled: false,
														});
													}}
													ref={(ref) => {
														this.narDuStarterAudioPlayer =
															ref;
													}}
													refs={this.audioRefs}
													src={
														assignment.partialAnswerSound
													}
												/>
												{''}
											</p>
										</>
									);
								}
								const wrongAnswerFeedBack = (
									<>
										<br />
										<p className="feedback">
											<span
												className={
													'visually-hidden-audio'
												}
											>
												<AudioPlayer
													autoplay
													strokeColor="#ed381dff"
													outlineColor="#4f5151ff"
													inline
													onErrorPlay={() => {
														console.log(
															'Something went wrong'
														);
													}}
													onComplete={() => {
														const isMultiChoice =
															order.length > 1;

														if (isMultiChoice) {
															choices.forEach(
																(choice) => {
																	choice.choiceGroup.forEach(
																		(
																			group
																		) => {
																			group.currentClass =
																				'imgItem';
																		}
																	);
																}
															);
															answerArray = [];
														} else {
															choices.forEach(
																(choice) => {
																	choice.choiceGroup.forEach(
																		(
																			group
																		) => {
																			if (
																				group.groupId ===
																				this
																					.state
																					.selectedGroupId
																			) {
																				group.currentClass =
																					'imgItem';
																			}
																		}
																	);
																}
															);
														}
														singleAssignment[
															this.state.counter
														] = [assignment];
														this.setState({
															singleAssignment,
															wrongAnswerDetected: false,
															hoverDisabled: false,
														});
													}}
													ref={(ref) => {
														this.narDuStarterAudioPlayer =
															ref;
													}}
													refs={this.audioRefs}
													src={
														assignment.wrongAnswerSound
													}
												/>
												{assignment.wrongAnswerText}
											</span>

											<span
												className="lit-feedback-pill is-wrong"
												role="status"
												aria-live="polite"
												aria-label="Feil"
											/>
										</p>
									</>
								);
								const correctAnswerFeedBack = (
									<>
										<p className="feedback">
											<span
												className={
													'visually-hidden-audio'
												}
											>
												<AudioPlayer
													autoplay
													strokeColor="#2dfd0dff"
													outlineColor="#4f5151ff"
													inline
													onErrorPlay={() => {
														console.log(
															'Something went wrong'
														);
													}}
													onComplete={() => {
														answerArray = [];
														count = count + 1;
														this.updateCount();
														this.setState({
															correctAnswerDetected: false,
															showOptions: true,
															hoverDisabled: false,
														}); //make false
													}}
													ref={(ref) => {
														this.narDuStarterAudioPlayer =
															ref;
													}}
													refs={this.audioRefs}
													src={
														assignment.rightAnswerSound
													}
												/>
												{assignment.rightAnswerText}
											</span>

											<span
												className="lit-feedback-pill is-correct"
												role="status"
												aria-live="polite"
												aria-label="Riktig"
											/>
										</p>
									</>
								);

								if (this.state.showTestPanel && count < 3) {
									return (
										<div
											className="lit-illustrations-wrapper"
											key={id}
										>
											<div className="lit-single-word">
												<p className="instruction">
													<span className="audio-with-step">
														<AudioPlayer
															inline
															strokeColor="#f9fcfcff"
															outlineColor="#4f5151ff"
															id={
																singleAssignment[
																	count
																].id
															}
															key={
																singleAssignment[
																	count
																].id
															}
															autoplay
															onErrorPlay={() => {
																console.log(
																	'Something went wrong'
																);
																this.setState({
																	showOptions: true,
																});
															}}
															onComplete={() => {
																this.setState({
																	showOptions: true,
																});
															}}
															ref={(ref) => {
																this.narDuStarterAudioPlayer =
																	ref;
															}}
															refs={
																this.audioRefs
															}
															src={
																assignment.mainSound
															}
														/>
														<span
															className="tutorial-step-badge"
															aria-label={`Trinn ${count} av 2`}
														>
															<span className="current">
																{count}
															</span>
															<span className="sep">
																av
															</span>
															<span className="total">
																2
															</span>
														</span>
													</span>
												</p>
											</div>
											<div className="lit-options">
												<div className="lit-words-wrapper">
													<div className="lit-image-grid">
														{choices.map(
															(choice, i) => {
																const {
																	choiceGroup,
																} = choice;
																return (
																	// eslint-disable-next-line react/jsx-key
																	<div>
																		{this
																			.state
																			.showOptions && (
																			<div className="lit-tutorial-illustrations-list ">
																				<br />
																				{choiceGroup.map(
																					(
																						group
																					) => {
																						const isSelected =
																							answerArray.includes(
																								group.word
																							);
																						const selectionIndex =
																							answerArray.indexOf(
																								group.word
																							);
																						const idWord =
																							i +
																							group.word;
																						const {
																							groupId,
																						} =
																							group;
																						const {
																							currentClass,
																						} =
																							group;

																						return (
																							<span
																								className="lit-word"
																								key={
																									idWord
																								}
																							>
																								<span className="imgItemWrapper">
																									{this
																										.state
																										.counter >
																										3 &&
																										isSelected && (
																											<span className="imgItem__badge">
																												{selectionIndex +
																													1}
																											</span>
																										)}
																									<img
																										onClick={() => {
																											if (
																												order.length !==
																													answerArray.length &&
																												!this
																													.state
																													.wrongAnswerDetected
																											) {
																												this.recordAnswerSetSyle(
																													singleAssignment[
																														this
																															.state
																															.counter
																													],
																													groupId,
																													order.length
																												);
																											}

																											if (
																												order.length <
																													3 &&
																												order.length ===
																													answerArray.length
																											) {
																												this.setState(
																													{
																														correctAnswerDetected: true,
																													}
																												);
																											}
																										}}
																										className={
																											currentClass +
																											(this
																												.state
																												.hoverDisabled
																												? ' no-hover'
																												: '')
																										}
																										src={
																											group.img
																										}
																										alt={
																											group.word
																										}
																									/>
																								</span>
																							</span>
																						);
																					}
																				)}
																			</div>
																		)}
																	</div>
																);
															}
														)}
													</div>
												</div>
											</div>

											{this.state.wrongAnswerDetected &&
												wrongAnswerFeedBack}
											{this.state.correctAnswerDetected &&
												correctAnswerFeedBack}
											{this.state.halfAnswerDetected &&
												partialAnswerFeedback}
										</div>
									);
								}
							}
						)}
				</div>
				{isNextButtonVisible && (
					<p className="feedback" style={{marginTop: '10px'}}>
						<AudioPlayer
							inline
							autoplay
							onErrorPlay={() => {
								console.log('Something went wrong');
							}}
							ref={(ref) => {
								this.narDuStarterAudioPlayer = ref;
							}}
							refs={this.audioRefs}
							src={this.starterTestenSound}
						/>
						{strings.sprakforstaelseStarterTesten}
					</p>
				)}
				{isNextButtonVisible && (
					<button
						className="lit-btn bg-primary"
						onClick={() => {
							onNextStep(results);
							this.props.onShowAvatar(false);
						}}
					>
						{strings.startTest}
					</button>
				)}
				{this.state.nextTutorial && count < 3 && (
					<button
						className="lit-btn bg-primary"
						onClick={() => {
							this.setState({
								showTestPanel: true,
								nextTutorial: false,
							});
							this.props.onShowAvatar(false);
						}}
					>
						{'Neste'}
					</button>
				)}
			</div>
		);
	}
}

const mapStateToProps = (state) => {
	const {candidateGrade} = state;
	return {
		candidateGrade,
	};
};

export default connect(mapStateToProps)(Tutorial);
